import type { FC } from "react";
import { useTranslation } from "react-i18next";
import type { ScheduleWeeks } from "../../hooks/useScheduleWeeks";
import { ScheduleLoadFallback } from "./ScheduleLoadFallback";

type Props = { load: Pick<ScheduleWeeks, "isLoading" | "isError" | "refetch">; dataTestId: string };

/** What a page built on many schedule weeks shows before they're in: a spinner, or the error with Retry. */
export const PageScheduleFallback: FC<Props> = ({ load, dataTestId }) => {
	const { t } = useTranslation();
	return <ScheduleLoadFallback load={load} errorTitle={t("schedule.page.load.failed")} dataTestId={dataTestId} />;
};
